import { BaseService } from './BaseService';

export const TransacaoEmpenhoSIAFService = {
    async search(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('transacoes-empenho-siaf/search', filter);
        } catch (error) {
            console.error('Erro ao buscar transações de empenho SIAF:', error);
            return false;
        }
    }
};

